export default __webpack_public_path__ + "static/media/bsc-logo.27f54c9b.png";